import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  createCampaignRequest,
  createCampaignSuccess,
  createCampaignFailure,
  type CampaignCreationPayload,
} from '../slices/campaignCreationSlice';
import { ENDPOINTS } from '../../api/endPoints';

function* createCampaignSaga(action: PayloadAction<CampaignCreationPayload>): Generator<any, void, any> {
  try {
    console.log('🚀 Campaign Creation Saga - START');
    console.log('Payload:', action.payload);

    // Get restaurant ID from URL path (e.g., /4bebbb8a.../campaigns)
    const pathParts = window.location.pathname.split('/');
    const restaurantId = pathParts[1];
    const accountId = '';

    if (!restaurantId) {
      throw new Error('Missing restaurant-id in URL');
    }

    // Build URL and configuration
    const url = ENDPOINTS.createCampaign;
    const headers = {
      'Content-Type': 'application/json',
      'restaurant-id': restaurantId,
      'account-id': accountId,
    };
    
    console.log('Making POST request to:', url);

    const response = yield call(axios.post, url, action.payload, { headers });

    console.log('✅ Campaign created successfully:', response.data);

    yield put(createCampaignSuccess(response.data));
  } catch (error: any) {
    console.error('❌ Campaign creation failed:', error);
    const errorMessage = error.response?.data?.message || 
                        error.message || 
                        'Failed to create campaign';
    yield put(createCampaignFailure(errorMessage));
  }
}

export default function* campaignCreationSagaWatcher() {
  yield takeLatest(createCampaignRequest.type, createCampaignSaga);
}
